<style lang="less" scoped>
@import '../../../style/common/variable';
.searchBarKYJS {position: relative;
ul {display: flex;list-style: none;width: 1200px;}
li {float: left;margin-right: 21px;font-size: 14px;}
.input {width: 166px !important;font-family: MicrosoftYaHei;font-size: 14px !important;;}
.el-select {width: 166px !important;font-family: MicrosoftYaHei;}
.button {width: 40px !important;height: 40px !important;font-size: 24px;background-color: white;border: solid rgb(219, 216, 216);border-width: 1px;border-radius: 5px;cursor: pointer;}}
.button:active{color:#13569e;}
@media screen and (max-width: @max-screen) {
  .searchBarKYJS{
    ul{width: 100%;}
  }
}
</style>

<template>
  <div class="searchBarKYJS">
    <ul>
      <li>
        <el-select v-model="JiaoYi" placeholder="交易类型" :clearable="true">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li v-if="ifShowFlag">
        <el-select v-model="YaoJi" placeholder="药剂类型" :clearable="true">
          <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li v-if="ifShowFlag">
        <el-select v-model="GuoJia" placeholder="国家" :clearable="true">
          <el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <el-input class="input" v-model="Input" placeholder="请输入关键词"></el-input>
      </li>
      <li>
        <button class="button" @click="searchdata([JiaoYi, YaoJi, GuoJia, Input])"><i class="el-icon-search"></i></button>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 2021.7.12
 * 搜索栏：三个select框、一个input框、一个搜索按钮，根据设置的条件搜索数据
 */
export default {
  data()
  {
    return {
      options1: [
        { id: '选项1', name: '供应', value: '1' },
        { id: '选项2', name: '求购', value: '0' }
      ],
      JiaoYi: '',
      options2: [],
      YaoJi: '',
      options3: [
        { id: '选项1',  name: '中国',      value: 2 },
        { id: '选项2',  name: '印度尼西亚', value: 3 },
        { id: '选项3',  name: '马来西亚',   value: 4 },
        { id: '选项4',  name: '菲律宾',     value: 5 },
        { id: '选项5',  name: '新加坡',     value: 6 },
        { id: '选项6',  name: '泰国',       value: 7 },
        { id: '选项7',  name: '文莱',       value: 8 },
        { id: '选项8',  name: '越南',       value: 9 },
        { id: '选项9', name: '老挝',       value: 10 },
        { id: '选项10', name: '缅甸',       value: 11 },
        { id: '选项11', name: '柬埔寨',     value: 12 },
        { id: '选项12', name: '其他',       value: 13 }
      ],
      GuoJia: '', // 选中的国家
      Input: '', // 输入的关键词
      ifShowFlag: true
    }
  },
  created()
  {
    this.getOptions2()
  },
  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },
  methods: {
    getOptions2()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=30', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.options2 = []
        ret[0].data.forEach((item, index) =>
        {
          this.options2.push({id: `选项${index + 1}`, name: item.dispc, value: item.id})
        })
      })
    },
    searchdata(arr)
    {
      this.$emit('searchdata', arr)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SearchBarKYJS.vue